import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import { Loader } from 'semantic-ui-react';
import { createGlobalStyle } from 'styled-components';
import api from 'api';
import actions from 'actions';
import NavBar from 'components/includes/NavBar';
import Footer from 'components/includes/Footer';

import ParticipantLogin from './entry/ParticipantLogin';
import Participate from './participants/Participate';
import ParticipateStage from './participants/ParticipateStage';

const GlobalStyle = createGlobalStyle`
  body, p, h1, h2, h3, .header, .ui.header, .ui.button{
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";
  }

  a{
    color:rgb(108, 97, 244);
    &.with-border{
      border-bottom: 1px dotted rgb(108, 97, 244);
    }
    &:hover{
      color:rgb(108, 97, 244);
    }
  }

  .participant-view{
    p, label {
      font-size:120%;
    }
  }

  .text-right{
    text-align:right;
  }
  .text-center{
    text-align:center;
  }
  .float-right{
    float: right;
  }
  .ui.white.button{
    background:white;
  }

  .break-lines{
    white-space: pre-line;
  }

  .nav-bar{
    height:60px;
    padding: 13px 20px;

    .logo{
      max-height: 40px;
      max-width: 200px;
      vertical-align: middle;
    }
    .button{
      margin-left:12px;
    }
    .nav-bar-link{
      margin-right:12px;
      font-weight:700;
    }

    .nav-bar-right{
      float:right;
    }

    .nav-bar-item{
      color:white;
      margin-left:20px;
      line-height:40px;
    }

    .nav-bar-circular-item{
      margin-left:20px;
      margin-top:5px;
      height:40px;
      width:40px;
      line-height:30px;
      font-size:20px;
      text-align:center;
      background:rgba(250,250,250, 0.3);
      color:white;
      border-radius:50%;
      >.icon{
        margin-left:4px;
        margin-top:4px;
      }
    }
  }

  .only-mobile{
    @media only screen and (min-width: 768px) {
      display:none;
    }
  }
  .above-mobile{
    @media only screen and (max-width: 767px) {
      display:none;
    }
  }

  .rc-slider{
    max-width:80%;
    display:block;
    margin: 20px auto;
    .rc-slider-rail{
      height:10px;
    }
    .rc-slider-track{
      height:10px;
    }
    .rc-slider-handle{
      width:50px;
      height:50px;
      margin-top:-20px;
      margin-left:-25px;
    }
  }

  .empty-box{
    border: 1px dashed rgb(210,210,210);
    padding: 60px 10px;
    text-align:center;
    .empty-box-header{
      font-size: 25px;
      margin-bottom: 20px;
      line-height: 30px;
    }
  }

  .marketing{
    .banner{
      margin-top:-60px;
      padding-top: 60px;
      min-height:450px;
      background: rgb(253,166,130);
      background: linear-gradient(90deg, rgba(253,166,130,1) 0%, rgba(253,130,174,1) 100%);
      background-size:cover;

      h1, p {
        color:white;
      }
      h1 {
        font-size:30px;
      }
      p {
        font-size:18px;
      }
    }
    .quick-login{
      padding: 10px;
      border-radius:4px;
      background: rgba(250,250,250,0.75);
      box-shadow: inset 0px 0px 4px 6px rgba(0,0,0,0.05);
      display:inline-block;
      color:black;
      h3, .ui.form label{
        margin-top:0px;
        color:black;
      }
      button.ui.button.login{
        margin-top:25px;
      }
    }

    .floating-banner{
      background-attachment: scroll;
      background-clip: border-box;
      background-color: #fff;
      border-radius: 15px;
      box-shadow: rgba(0,0,0,.41) -1px 5px 33px -7px;
      margin: 0;
      padding: 20px 20px;
      position: relative;
    }
  }

  .admin-dashboard{
    display: flex;
    .admin-dashboard-side{
      position:relative;
      z-index:20;
      background-color: #051d39;
      background-image: linear-gradient(to right, #051d39 , #1e344d);
      width: 200px;
      height:100vh;
      position:sticky;
      top:0px;
      .admin-dashboard-side-logo-holder{
        width:130px;
        padding:10px;
        img{
          width:100%;
          opacity:1;
        }
      }
      .admin-dashboard-side-section{
        width:200px;
        padding:10px;
        h4{
          color:#677694;
          text-transform:uppercase;
          font-size:14px;
        }
        .admin-dashboard-nav-link{
          color:white;
          display:block;
          margin-bottom:5px;
          margin-left:-10px;
          margin-right:-10px;
          padding:5px 10px;
          transition: background 0.5s;
          &.active{
            background:rgba(250,250,250,0.2);
            font-weight:bold;
          }
          &:hover:not(.active){
            background:rgba(250,250,250,0.04);
          }
        }
      }
    }
    .admin-dashboard-main{
      flex:1;
      position:relative;
      z-index:10;
    }
  }

`

class App extends Component {
  componentWillMount() {
    api.participants.autoLogin(this.props.onParticipantLoginSuccess);
  }

  componentDidUpdate(prevProps) {
    if(this.props.location !== prevProps.location) {
      window.scrollTo(0, 0)
    }
  }

  render() {
    const { loadingMe, participantIsAuthenticated } = this.props;
    return (
      <div>
        <GlobalStyle />
        {loadingMe && <Loader active />}
        <div style={{flex: 1}}>
          {participantIsAuthenticated ?
            <div style={{display:'flex', flexDirection: 'column', minHeight: '100vh'}}>
              <NavBar />
              <div style={{flex:1, display:'block'}}>
                <Switch>
                  <Route path='/participate/:stageId' component={ParticipateStage} />
                  <Route path='/login' component={ParticipantLogin} />
                  <Route exact path='/' component={Participate} />
                  <Route component={ParticipantLogin} />
                </Switch>
              </div>
              <Footer />
            </div>
          :
            <Switch>
              <Route component={ParticipantLogin} />
            </Switch>
          }
          <ToastContainer position={toast.POSITION.TOP_CENTER} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return { loadingMe: state.participants.isLoadingMe, participantIsAuthenticated: state.participants.isAuthenticated };
};
const mapDispatchToProps = dispatch => ({
  onParticipantLoginSuccess: token => dispatch(actions.participants.receiveLogin(token)),
});

const AppContainer = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(App));

export default AppContainer;
